import { useState } from 'react'

import { getProfileContactsApi, ProfileContactsWidget } from '../../../Widget'

function UserProfileWidgetContacts({
  canEdit,
  getApi = getProfileContactsApi,
  profileId,
  onClickEmail,
}) {
  const [showWidget, setShowWidget] = useState(true)

  const api = getApi({ profileId })

  function handleHideWidget() {
    setShowWidget(false)
  }

  return showWidget ? (
    <ProfileContactsWidget
      api={api}
      canEdit={canEdit}
      onClickEmail={onClickEmail}
      onHideWidget={handleHideWidget}
    />
  ) : null
}

export default UserProfileWidgetContacts
